var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconElevator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57893 11.375H4.51321C3.95455 11.375 3.5 10.9204 3.5 10.3618V5.29607C3.5 4.73741 3.95455 4.28286 4.51321 4.28286H9.57893C10.1376 4.28286 10.5921 4.73741 10.5921 5.29607V10.3618C10.5921 10.9204 10.1376 11.375 9.57893 11.375ZM7.55267 10.3618H9.57893V5.29607H7.55267V10.3618ZM4.51321 5.29607V10.3618H6.53947V5.29607H4.51321ZM8.56588 3.523C8.43624 3.523 8.30661 3.4736 8.20768 3.37467L7.44781 2.6148C7.24994 2.41693 7.24994 2.09627 7.44781 1.8984C7.64568 1.70053 7.96634 1.70053 8.16421 1.8984L8.56588 2.30007L8.96754 1.8984C9.16541 1.70053 9.48608 1.70053 9.68395 1.8984C9.88181 2.09627 9.88181 2.41693 9.68395 2.6148L8.92408 3.37467C8.82514 3.4736 8.69551 3.523 8.56588 3.523ZM6.28628 3.523C6.15665 3.523 6.02701 3.4736 5.92808 3.37467L5.52641 2.973L5.12475 3.37467C4.92688 3.57254 4.60621 3.57254 4.40834 3.37467C4.21048 3.1768 4.21048 2.85614 4.40834 2.65827L5.16806 1.8984C5.36593 1.70053 5.68659 1.70053 5.88446 1.8984L6.64433 2.65827C6.8422 2.85614 6.8422 3.1768 6.64433 3.37467C6.54539 3.4736 6.41576 3.523 6.28613 3.523H6.28628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElevator);
export default __webpack_public_path__ + "static/media/icon-elevator.d83d407e40ba936d223503a54f7f48e4.svg";
export { ForwardRef as ReactComponent };